import { render, staticRenderFns } from "./HeaderOnboardingScreen.vue?vue&type=template&id=9d7a46c8&scoped=true&"
import script from "./HeaderOnboardingScreen.vue?vue&type=script&lang=js&"
export * from "./HeaderOnboardingScreen.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOnboardingScreen.vue?vue&type=style&index=0&id=9d7a46c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a46c8",
  null
  
)

export default component.exports